import { configureStore } from "@reduxjs/toolkit";
import datasReducer from "./reducers/datasReducer";
import spinnerReducer from "./reducers/spinnerSlice";
import toasterReducer from "./reducers/toasterReducer";

export const store = configureStore({
  reducer: {
    spinner: spinnerReducer,
    toaster: toasterReducer,
    data: datasReducer,
  },
});

export default store;
